// src/utils/axiosSetup.ts
import axios from 'axios';

// --- Set initial token on first page load ---
const tokenStorage = JSON.parse(localStorage.getItem('token-storage') || '{}');
const accessToken = tokenStorage?.access_token;

if (accessToken) {
  axios.defaults.headers.common['Authorization'] = accessToken;
  axios.defaults.headers.common['Cache-Control'] = 'no-store';
}

export default axios;
